import SkipToMain from './components/ui/SkipToMain'

export default function () {
  return { component: SkipToMain }
}
